import { useList } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { ElementoStradale } from "../types"

export function useElementiStradaliList(params: Record<string, string | string[] | number[] | number> = {}) {
  return useList<ElementoStradale>(`${API_URL}/elementi-stradali`, { query: params })
}